import { Stack, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import { Box } from "@mui/system";
import AnomaliesSortByDrawer from "../../Common/AnomaliesSortByDrawer";
import AnomaliesDateRangeField from "../../Common/AnomaliesDateRangeField";
import BeAwareBrandSearchDrawer from "../../../../BeAware/BeAwareMobileContent/BeAwareBrandSearchDrawer";
import { getIncomeMTDDateRange } from "../../../../../../../helpers/bizDevelopmentDashboardHelpers";
import type { AnomaliesSortOption } from "../../Common/anomaliesSort";

interface IncomeGapsFilterProps {
  brandCount?: number;
  onDownload?: () => void;
  downloadDisabled?: boolean;
  sortKey: string;
  sortDir: "asc" | "desc";
  onApplySort: (key: string, dir: "asc" | "desc") => void;
  sortOptions: AnomaliesSortOption[];

  brandList?: string[];
  brandName?: string;
  onBrandNameChange?: (value: string) => void;
}

const IncomeGapsFilter = ({
  brandCount = 0,
  onDownload,
  downloadDisabled = false,
  sortKey,
  sortDir,
  onApplySort,
  sortOptions,
  brandList = [],
  brandName = "",
  onBrandNameChange,
}: IncomeGapsFilterProps) => {
  const { start, end } = getIncomeMTDDateRange();
  const dateRangeLabel = `MTD, ${start.format("DD/MM/YYYY")} - ${end.format(
    "DD/MM/YYYY",
  )}`;

  return (
    <>
      <AnomaliesDateRangeField label={dateRangeLabel} />

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          mt: spacing.Spacing.md.$value,
          color: colors.GrayLightMode[900].$value,
        }}
      >
        <Box>
          <Typography
            display={"flex"}
            alignItems={"center"}
            flexDirection={"row"}
            gap={1}
            sx={{
              fontSize: typography.Size.Text.xs.$value,
              fontWeight: typography.Font_weight.Regular.$value,
            }}
          >
            Sort by:{" "}
            <AnomaliesSortByDrawer
              options={sortOptions}
              sortKey={sortKey}
              sortDir={sortDir}
              onApply={onApplySort}
              dataTracker="914"
            />
          </Typography>
          <Typography
            sx={{
              fontSize: typography.Size.Text.xs.$value,
              mt: spacing.Spacing.sm.$value,
            }}
          >
            {brandCount} Brands
          </Typography>
        </Box>

        <Box>
          <BeAwareBrandSearchDrawer
            brandList={brandList}
            brandName={brandName}
            onBrandNameChange={onBrandNameChange}
            dataTracker="915"
          />
          <IconButton
            color="secondary"
            size="large"
            onClick={onDownload}
            disabled={downloadDisabled}
            data-tracker="913"
          >
            <FileDownloadIcon
              sx={{ color: colors.GrayLightMode[700].$value }}
            />
          </IconButton>
        </Box>
      </Stack>
    </>
  );
};

export default IncomeGapsFilter;
